import App from 'app/app.js';
import 'app/directive/LtStudentPortraitInformationCtrl.js';

function LtStudentPortraitInformationDirective() {
  return {
    restrict: 'E',
    scope: {
      data: '=',
      onSubmit: '&'
    },
    template:
      '<div class="row">' +
      '    <div class="col-xs-12">' +
      '        <ul>' +
      '            <li>' +
      '                <h5 lt-translate="STUDENT_PORTRAIT_INFORMATION_TITLE" class="portrait-info"></h5>' +
      '                <p lt-translate="STUDENT_PORTRAIT_INFORMATION_DESCRIPTION" lt-translate-values="{link: \'#{{studentPortraitInformation.getGetStartedPath()}}\'}"></p>' +
      '            </li>' +
      '            <li><label lt-translate="STUDENT_PORTRAIT_INFORMATION_FIRST_NAME_LABEL"></label></li>' +
      '            <li><input name="studentFirstName" ng-model="data.studentFirstName" placeholder="{{studentPortraitInformationCtrl.getPlaceholder(\'STUDENT_PORTRAIT_INFORMATION_FIRST_NAME_PLACEHOLDER\')}}" data-test-student-first-name type="text" maxlength="30" required lt-key-filter="name"></li>' +
      '            <li><label lt-translate="STUDENT_PORTRAIT_INFORMATION_LAST_NAME_LABEL"></label></li>' +
      '            <li><input name="studentLastName" ng-model="data.studentLastName" placeholder="{{studentPortraitInformationCtrl.getPlaceholder(\'STUDENT_PORTRAIT_INFORMATION_LAST_NAME_PLACEHOLDER\')}}" data-test-student-last-name type="text" maxlength="30" required lt-key-filter="name"></li>' +
      '            <li><label lt-translate="STUDENT_PORTRAIT_INFORMATION_PORTRAIT_ID_LABEL"></label></li>' +
      '            <li><input name="portraitId" ng-model="data.portraitId" placeholder="{{studentPortraitInformationCtrl.getPlaceholder(\'STUDENT_PORTRAIT_INFORMATION_PORTRAIT_ID_PLACEHOLDER\')}}" data-test-portrait-id type="text" maxlength="10" required lt-key-filter="name"></li>' +
      '            <li><label lt-translate="STUDENT_PORTRAIT_INFORMATION_ACCESS_CODE_LABEL"></label></li>' +
      '            <li><input name="accessCode" ng-model="data.accessCode" placeholder="{{studentPortraitInformationCtrl.getPlaceholder(\'STUDENT_PORTRAIT_INFORMATION_ACCESS_CODE_PLACEHOLDER\')}}" data-test-access-code type="text" maxlength="4" required lt-key-filter="name"></li>' +
      '        </ul>' +
      '    </div>' +
      '</div>' +
      '<div class="row">' +
      '    <div class="col-xs-12 col-md-6 col-md-offset-3">' +
      '        <a class="btn blue submit" lt-translate="STUDENT_PORTRAIT_INFORMATION_SUBMIT" data-test-information-submit ng-click="studentPortraitInformation.submit();formSubmit=submitted"></a>' +
      '    </div>' +
      '</div>',
    controller: 'LtStudentPortraitInformationCtrl',
    controllerAs: 'studentPortraitInformation'
  };
}

App.directive('ltStudentPortraitInformation', [LtStudentPortraitInformationDirective]);
